export default __webpack_public_path__ + "static/media/kazinform.5e6e7682.svg";